/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Applied_SuccessInputs */

const en_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing applied successfully`)
};

const fr_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutage appliqué avec succès`)
};

const de_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing erfolgreich angewendet`)
};

const it_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempistica applicata correttamente`)
};

const ru_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успешно применено временное ограничение.`)
};

const es_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo aplicado exitosamente`)
};

const zh_cn2_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计时应用成功`)
};

const ja_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングが正常に適用されました`)
};

const hi_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय सफलतापूर्वक लागू हो गया`)
};

const pt_pt2_timing_applied_success = /** @type {(inputs: Timing_Applied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometragem aplicada com sucesso`)
};

/**
* | output |
* | --- |
* | "Timing applied successfully" |
*
* @param {Timing_Applied_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_applied_success = /** @type {((inputs?: Timing_Applied_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Applied_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_applied_success(inputs)
	if (locale === "de") return de_timing_applied_success(inputs)
	if (locale === "it") return it_timing_applied_success(inputs)
	if (locale === "ru") return ru_timing_applied_success(inputs)
	if (locale === "es") return es_timing_applied_success(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_applied_success(inputs)
	if (locale === "ja") return ja_timing_applied_success(inputs)
	if (locale === "hi") return hi_timing_applied_success(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_applied_success(inputs)
	return en_timing_applied_success(inputs)
});